const {Component} = React;
const {createPortal, render} = ReactDOM;

class ShoppingCart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cart: {}
        };

        this._requestList = this._requestList.bind(this);
        this._add = this._add.bind(this);
        this._decrement = this._decrement.bind(this);
        this._remove = this._remove.bind(this);
        this._refresh = this._refresh.bind(this);
    }

    componentDidMount() {
        this._requestList();
    }

    _requestList() {
        $.get('/cart', data => this.setState({cart: JSON.parse(data) || {}}, () => {
            const {cart} = this.state;
            if (!cart) return;
            const badge = $('#cart-badge');
            $('span', badge).text(cart.total);
        }));
    }

    _refresh(res) {
        if (!res) return;
        this._requestList();
        $.toast({
            heading: 'Giỏ hàng',
            text: 'Cập nhật thành công',
            icon: 'success',
            bgColor: 'green',
            position: 'bottom-right'
        });
    };

    _add(e, id) {
        e.preventDefault();
        $.post('/shopping-cart/add', {id: id}, this._refresh);
        return false;
    }

    _decrement(e, id) {
        e.preventDefault();
        $.post('/shopping-cart/decrement', {id: id}, this._refresh);
        return false;
    }

    _remove(e, id) {
        e.preventDefault();
        if (confirm('Xác nhận xoá đi sản phẩm này trong giỏ hàng?')) {
            $.post(e.currentTarget.getAttribute('href'), {id}, this._refresh);
        }
        return false;
    }

    render() {
        const {cart} = this.state;

        if (!cart || !cart.hasOwnProperty('items') || !Object.keys(cart.items).length) {
            return (
                <div className="empty-block">
                    <img src="/images/no-content.jpg" alt="No content"/>
                    <h4>Giỏ hàng đang trống </h4>
                </div>
            );
        }
        let item;
        return (
            <div>
                <table className={'table cart-table table-striped'}>
                    <thead>
                    <tr>
                        <th></th>
                        <th>Sản phẩm</th>
                        <th>Số lượng</th>
                        <th>Đơn giá</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Object.keys(cart.items).map((idx) => !(item = cart.items[idx]) ? null : (
                        <tr key={`Item${idx}`}>
                            <td>
                                <img src={item.data.image} alt={item.data.title} style={{width: 40}}/>
                            </td>
                            <td>{item.data.title}</td>
                            <td>
                                <div className={'input-number'}>
                                    <span className={'cart-qty'}>{item.quantity}</span>
                                    <span className={'qty-up'} onClick={e => this._add(e, idx)}>+</span>
                                    <span className={'qty-down'} onClick={e => this._decrement(e, idx)}>-</span>
                                </div>
                            </td>
                            <td>{item.sum ? new Intl.NumberFormat('vi-VN').format(item.sum) : 0} đ</td>
                            <td>
                                <a
                                    className={'cart-remove'}
                                    href={'/shopping-cart/remove'}
                                    onClick={e => this._remove(e, idx)}
                                >
                                    <i className={'fa fa-trash'}/>
                                </a>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    <tbody>
                    <tr>
                        <td colSpan={3} className={'text-right'}><b>TỔNG TIỀN: </b></td>
                        <td>{cart.sum ? new Intl.NumberFormat('vi-VN').format(cart.sum) : 0} đ</td>
                        <td/>
                    </tr>
                    </tbody>
                </table>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p>
                            <a href="/checkout" className="btn btn-danger btn-custom-red order-submit">Tính tiền</a>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

let wrap;
if ((wrap = document.getElementById('cart-content'))) {
    render(<ShoppingCart/>, wrap);
}